<style scoped>
.h-btn {
    min-width: 200px;
}

.no-href-dec {
    text-decoration: none;
    cursor: pointer;
}
.branch-select{
    min-width:200px
}
._btn {
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
    vertical-align: middle;
    padding: 7px 12px;
}

._btn {
    margin: 0 !important;
    line-height: 1;
    color:#fff;
}
.staff-service-card {
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 7px;
    padding: 16px 18px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 85px;
}

.staff-info {
    min-width: 0;
    padding-right: 12px;
}

.staff-info h6 {
    margin: 0 0 5px;
    font-size: 15px;
    font-weight: 600;
    color: #343a40;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.staff-info span {
    font-size: 12px;
    color: #6c757d;
}

/* Service counter */

.staff-services {
    width: 58px;
    height: 58px;
    border-radius: 50%;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    flex-shrink: 0;
    color: #fff;
}

.staff-services strong {
    font-size: 17px;
    font-weight: 700;
    line-height: 18px;
}

.staff-services small {
    font-size: 8px;
    text-transform: uppercase;
    line-height: 10px;
}


/* Success */

.success-card {
    border-left: 3px solid #198754;
}

.success-card .staff-services {
    background: #198754;
}


/* Primary */

.primary-card {
    border-left: 3px solid #0d6efd;
}

.primary-card .staff-services {
    background: #0d6efd;
}


/* Warning */

.warning-card {
    border-left: 3px solid #ffc107;
}

.warning-card .staff-services {
    background: #ffc107;
    color: #212529;
}


/* Danger */

.danger-card {
    border-left: 3px solid #dc3545;
}

.danger-card .staff-services {
    background: #dc3545;
}
</style>
<template>
    <!-- Content -->
    <div class="content-wrapper">
        <div class="row mb-3">
            <div class="col-md-12">
                <div class="row">
                    <div class="col-12 d-flex justify-content-between">
                    <h3 class="font-weight-bold">Comming Parcels</h3>
                    <span></span>
                   </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                    
                    <div class="row mb-3">
                        <div class="col-sm-6 col-md-3 col-12 stretch-card col-grid">
<input type="text" v-model="this.filter_parcel"
                                                class="form-control"
                                                placeholder="Search to filter">
                        </div>
                        
                           <div class="col-sm-12 col-md-3 col-12 stretch-card col-grid"></div>
                    <div class="col-sm-4 col-md-2 col-6 stretch-card col-grid">
 <input class="date_input form-control" v-model="this.fdate" type="date">
                    </div>
                    <div class="col-sm-4 col-md-2 col-6 stretch-card col-grid">
                         <input class="date_input form-control" type="date" v-model="this.tdate">
                    </div>
                    
                  
                    <div class="col-sm-4 col-md-2 col-6 stretch-card col-grid">
                         <button id="filter_btn" @click="filterParcels" class="btn btn-primary simple-btn">Filter</button>
                    </div>
                         
                    </div>
                  
                    <div class="row">
                        <div class="col-12">
                            <h4 class="my-3 text-center">{{heading}}</h4>
                              <div v-if="loading" class="mt-1">
                                                <div class="text-center">
                                                    <div class="spinner-grow text-success" role="status"></div>
                                                    <div class="spinner-grow text-danger" role="status"></div>
                                                    <div class="spinner-grow text-warning" role="status"></div>
                                                </div>
                                            </div>
                <div class="table-responsive">
                    
                    <table class="table table-striped mt-3">
                        <thead>
                            <tr class="thead-style">
                                <th>No</th>
                                <th> Parcel Name</th>
                                <th>Price</th>
                                <th> Receiver  </th>
                                <th  v-if="user.role == 4"> Sender </th>
                                <th> From - To </th>
                                <th  v-if="user.role < 4"> Served By </th>
                                <th> Sent - Shipped </th>
                                <th> Action </th>
                            </tr>
                        </thead>
                        <tbody id="incoming-list">

                            <tr v-for="(parcel, index) in paginatedParcels" :key="parcel.id" :id="'parcel_'+parcel.id">
                                <td>{{ (currentPage - 1) * perPage + index + 1 }}</td>
                               
                                 <td class="text-capitalize">
                                    <span class="d-block">{{ parcel.name }}</span>
                                    <span class="d-block mt-1 text-muted">{{ parcel.tag_name }}</span>
                                </td>
                                <td><label class="badge badge-dark"><PriceFormat :Price="parcel.price"/></label></td>
                                <td class="text-capitalize">
                                    <span class="d-block">{{ parcel.receiver_name }}</span>
                                    <span class="d-block mt-1 text-muted">{{ parcel.receiver_phone }}</span>
                                </td>
                                <td  v-if="user.role == 4" class="text-capitalize">
                                    <span class="d-block">{{ parcel.sender_name }}</span>
                                    <span class="d-block mt-1 text-muted">{{ parcel.sender_phone }}</span>
                                </td>
                                 <td class="text-capitalize">
                                    <span class="d-block">{{ parcel.branch_from_name }}</span>
                                    <span class="d-block mt-1 text-muted">{{ parcel.branch_to_name }}</span>
                                </td>
                               <td  v-if="user.role < 4" class="text-capitalize">
                                    <span class="d-block">{{ parcel.fulname }}</span>
                                    <span class="d-block mt-1 text-muted">{{ parcel.phone1 }}</span>
                                </td>
                                <td class="text-capitalize">
                                    <span class="d-block"><DateFormat :Date_="parcel.created_at"/></span>
                                    <span class="d-block mt-1 text-muted"><DateFormat :Date_="parcel.shipping_at"/></span>
                                </td>
            
                                <td>
                                    <button :disabled="this.loading_event" type="button" @click="pickParcel(parcel)"
                                        class="_btn btn receive_btn btn-primary">
                                         Pick
                                    </button>
                                </td>
                            </tr>
                          
                        </tbody>
                    </table>
                </div>
                           <div class="pagination-wrapper">

  <button 
    @click="currentPage--"
    :disabled="currentPage === 1">
    Prev
  </button>

  <button
    v-for="page in totalPages"
    :key="page"
    @click="currentPage = page"
    :class="{ active: currentPage === page }">
    {{ page }}
  </button>

  <button
    @click="currentPage++"
    :disabled="currentPage === totalPages">
    Next
  </button>

</div>
                        </div>
                    </div>

            </div>
        </div>
    </div>


</template>
<script>
import axios from "axios";

import PriceFormat from "@/components/PriceFormat.vue";
import PhoneFormat from "@/components/PhoneFormat.vue";
import DateFormat from "@/components/DateFormat.vue";


export default {
    components: {
        PriceFormat,
        PhoneFormat,
        DateFormat,

    },
    data() {
        return {
            loading: false,
            loading_event:false,
            search_staff:"",
            filter_parcel:"",
            heading:"To Days Incomming Parcels",
            parcels:[],
            og_parcels:[],
            parcel:{},
            fdate:"",
            tdate:"",
            currentPage: 1,
            perPage: 20,
            user: this.$attrs.user
        };
    },
    methods: {

        async pickParcel(parcel){

          this.loading_event = true

          var parcel_id = parcel.id
          var branch_id = parcel.branch_to

          var response = await axios
              .post(this.$store.state.api_url + "/service/pick-parcel", {parcel_id, branch_id})
              .catch((errors) => {
                    this.loading_event = false
                  var message = "Network or Server Errors";
                  this.$toast.error(message, { duration: 5000, dismissible: true });
              });

          //console.log(response.data)
          if (response.data.success) {

               this.loading_event = false
               this.removeParcel(parcel_id)

               var message = response.data.message;
              this.$toast.success(message, { duration: 5000, dismissible: true });

          } else {
                this.loading_event = false
              var message = response.data.message;
              this.$toast.error(message, { duration: 5000, dismissible: true });
          }

        },

        removeParcel(parcel_id) {
    this.parcels = this.parcels.filter(
        parcel => parcel.id != parcel_id
    );

    this.og_parcels = this.og_parcels.filter(
        parcel => parcel.id != parcel_id
    );
},
           
        async getParcels() {

            this.loading = true

            var response = await axios
                .get(this.$store.state.api_url + "/service/incomming-parcels")
                .catch((errors) => {
                    this.loading = false
                    var message = "Network or Server Errors";
                    this.$toast.error(message, { duration: 5000, dismissible: true });
                });

            //console.log(response.data)
            if (response.data.success) {
                this.loading = false
                this.parcels = response.data.parcels;
                this.og_parcels = response.data.parcels

               //console.log(this.parcels)

            } else {
                this.loading = false
                var message = response.data.message;
                this.$toast.error(message, { duration: 5000, dismissible: true });
            }
        },

          async filterParcels(){

             this.loading = true
          var fdate = this.fdate
          var tdate = this.tdate

          var response = await axios
              .post(this.$store.state.api_url + "/service/filter-incomming-parcels", {fdate, tdate})
              .catch((errors) => {
                    this.loading = false
                  var message = "Network or Server Errors";
                  this.$toast.error(message, { duration: 5000, dismissible: true });
              });

          //console.log(response.data)
          if (response.data.success) {

               this.loading = false

                this.parcels = response.data.parcels;
                this.og_parcels = response.data.parcels
               
                this.heading = "Incomming Parcels From ("+fdate+" To "+tdate+")"
             
          } else {
                this.loading = false
              var message = response.data.message;
              this.$toast.error(message, { duration: 5000, dismissible: true });
          }

        },
 
         nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++
    }
  },

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--
    }
  },

    },
      computed: {

  paginatedParcels() {
    const start = (this.currentPage - 1) * this.perPage
    const end = start + this.perPage

    return this.parcels.slice(start, end)
  },

  totalPages() {
    return Math.ceil(this.parcels.length / this.perPage)
  },
  

},
    watch: {

        filter_parcel(value) {

            let term = value.toLowerCase().trim()

            if (!term) {
                this.parcels = this.og_parcels
                return
            }

            this.parcels = this.og_parcels.filter(parcel => {

                return (
                    (parcel.name && parcel.name.toLowerCase().includes(term)) ||
                    (parcel.price && parcel.price.toLowerCase().includes(term)) ||
                    (parcel.sender_name && parcel.sender_name.toLowerCase().includes(term)) ||
                    (parcel.receiver_name && parcel.receiver_name.toLowerCase().includes(term)) ||
                    (parcel.receiver_phone && parcel.receiver_phone.toLowerCase().includes(term)) ||
                    (parcel.sender_phone && parcel.sender_phone.toLowerCase().includes(term)) ||
                    (parcel.tag_name && parcel.tag_name.toLowerCase().includes(term)) ||
                    (parcel.branch_from_name && parcel.branch_from_name.toLowerCase().includes(term))  ||
                    (parcel.branch_to_name && parcel.branch_to_name.toLowerCase().includes(term)) 
                )
            })
        },
 
    },
    created() {
        this.$store.state.page_name = "Dashbord"
        this.getParcels()
    },
    mounted() {
        //$('#dashbord').attr('class', 'nav-item active');
    }
};
</script>
